export default __webpack_public_path__ + "static/ef-b5a920cf9e2591683405b9759eb0875f.svg";